import { render, staticRenderFns } from "./PHelpModal.vue?vue&type=template&id=31003426&scoped=true&"
import script from "./PHelpModal.vue?vue&type=script&lang=js&"
export * from "./PHelpModal.vue?vue&type=script&lang=js&"
import style0 from "./PHelpModal.vue?vue&type=style&index=0&id=31003426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31003426",
  null
  
)

export default component.exports